// src/pages/applicantportal/routes.js
import MyApplicationsPage    from './MyApplicationsPage.vue'
import ApplicationDetailsPage from './ApplicationDetailsPage.vue'

export default [
  {
    path: '/my-applications',
    name: 'MyApplications',
    component: MyApplicationsPage,
    meta: { requiresAuth: true, roles: ['user', 'applicant'] }
  },
  {
    path: '/application/:id',
    name: 'ApplicationDetail',
    component: ApplicationDetailsPage,
    meta: { requiresAuth: true, roles: ['user', 'applicant'] }
  }
]
